import React, { useState, useEffect } from 'react';
import { FileText, Search, Shield } from 'lucide-react';
import { processSteps } from '../mock';

const iconMap = {
  FileText: FileText,
  Search: Search,
  Shield: Shield
};

const ProcessSlider = () => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % processSteps.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Simple 3-Step Process
          </h2>
          <p className="text-lg text-gray-600">
            Get your trademark registered in three easy steps
          </p>
        </div>

        {/* Desktop View */}
        <div className="hidden md:grid md:grid-cols-3 gap-8">
          {processSteps.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <div
                key={step.id}
                className="text-center p-6 rounded-lg bg-gray-50 hover:bg-brand-50 transition-all cursor-pointer"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-500 text-white rounded-full mb-4">
                  <Icon className="h-8 w-8" />
                </div>
                <div className="text-brand-500 font-bold text-lg mb-2">Step {step.id}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            );
          })}
        </div>

        {/* Mobile Slider */}
        <div className="md:hidden">
          <div className="relative">
            {processSteps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div
                  key={step.id}
                  className={`text-center p-6 rounded-lg bg-gray-50 transition-opacity duration-500 ${
                    index === currentStep ? 'opacity-100' : 'opacity-0 absolute inset-0'
                  }`}
                >
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-500 text-white rounded-full mb-4">
                    <Icon className="h-8 w-8" />
                  </div>
                  <div className="text-brand-500 font-bold text-lg mb-2">Step {step.id}</div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              );
            })}
          </div>

          <div className="flex justify-center mt-6 space-x-2">
            {processSteps.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentStep(index)}
                className={`h-2 rounded-full transition-all ${
                  index === currentStep ? 'w-8 bg-brand-500' : 'w-2 bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSlider;